
export class AsViewportOverlay extends HTMLElement{

  constructor(){
    super()
  }
  connectedCallback(){
    document.querySelector("as-app")
  }
}

customElements.define("as-viewport-overlay",AsViewportOverlay)